/* React */
import React from "react";

/* Ionic */
import { IonItemOption, IonIcon } from "@ionic/react";

/* Stylesheet */
import styles from "./ItemOption.module.scss";

/* Interfaces */
interface ItemOptionProps {
  label: string;
  icon: string;
  onClick: () => void;
  scssProps?: ScssProps;
}

interface ScssProps {
  backgroundColor?: string;
}

const ItemOption: React.FC<ItemOptionProps> = ({
  label,
  icon,
  onClick,
  scssProps,
}) => {
  return (
    <IonItemOption
      style={{ background: scssProps?.backgroundColor }}
      className={styles.item_option}
      onClick={onClick}
    >
      <div className={styles.wrapper_container}>
        <div className={styles.icon_container}>
          <IonIcon
            style={{ color: scssProps?.backgroundColor }}
            className={styles.icon}
            icon={icon}
          />
        </div>
        <div className={styles.label}>{label}</div>
      </div>
    </IonItemOption>
  );
};

export default ItemOption;
